export default "__VITE_ASSET__Ds149Or1__"